'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _director = require('./director.js');

Object.defineProperty(exports, 'reduce', {
  enumerable: true,
  get: function get() {
    return _director.reduce;
  }
});
Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _director.reduce;
  }
});

var _thunkedDirector = require('./thunked-director.js');

Object.defineProperty(exports, 'thunkedReduce', {
  enumerable: true,
  get: function get() {
    return _thunkedDirector.thunkedReduce;
  }
});

var _thunkify = require('./thunkify.js');

Object.defineProperty(exports, 'thunkify', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_thunkify).default;
  }
});

var _thunkifyClass = require('./thunkify-class.js');

Object.defineProperty(exports, 'thunkifyClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_thunkifyClass).default;
  }
});

var _memoize = require('./memoize.js');

Object.defineProperty(exports, 'memoize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_memoize).default;
  }
});

var _cloneReducer = require('./clone-reducer.js');

Object.defineProperty(exports, 'CloneReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cloneReducer).default;
  }
});

var _lazyCloneReducer = require('./lazy-clone-reducer.js');

Object.defineProperty(exports, 'LazyCloneReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lazyCloneReducer).default;
  }
});

var _monoidalReducer = require('./monoidal-reducer.js');

Object.defineProperty(exports, 'MonoidalReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_monoidalReducer).default;
  }
});

var _thunkedMonoidalReducer = require('./thunked-monoidal-reducer.js');

Object.defineProperty(exports, 'ThunkedMonoidalReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_thunkedMonoidalReducer).default;
  }
});

var _adapt = require('./adapt.js');

Object.defineProperty(exports, 'adapt', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adapt).default;
  }
});

var _reducers = require('./reducers.js');

Object.defineProperty(exports, 'PlusReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.PlusReducer;
  }
});
Object.defineProperty(exports, 'ThunkedPlusReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.ThunkedPlusReducer;
  }
});
Object.defineProperty(exports, 'ConcatReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.ConcatReducer;
  }
});
Object.defineProperty(exports, 'ThunkedConcatReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.ThunkedConcatReducer;
  }
});
Object.defineProperty(exports, 'AndReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.AndReducer;
  }
});
Object.defineProperty(exports, 'ThunkedAndReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.ThunkedAndReducer;
  }
});
Object.defineProperty(exports, 'OrReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.OrReducer;
  }
});
Object.defineProperty(exports, 'ThunkedOrReducer', {
  enumerable: true,
  get: function get() {
    return _reducers.ThunkedOrReducer;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }